// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PromoCode-promoCodeAccordionBtn-_HaCa {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: start;
    gap: 4px;
    padding: 0;
    background: transparent;
    border: unset;
    outline: unset;
    -webkit-box-shadow: unset;
            box-shadow: unset;
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    color: var(--primary-link-foreground);
    text-align: start;
}

.PromoCode-couponCodeTagSvg-Gnx_D {
    position: relative;
    top: -2px;
}

.PromoCode-promoCodeDropDownIcon-P_0TP {
    -webkit-transition: all 0.4s linear;
    transition: all 0.4s linear;
    position: relative;
    top: 3px;
}

.PromoCode-promoCodeAccordionOpen-WRsW7 .PromoCode-promoCodeDropDownIcon-P_0TP {
    -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
            transform: rotate(180deg);
    -webkit-transition: all 0.4s linear;
    transition: all 0.4s linear;
}

.PromoCode-promoCodeInputWrapper-S4hxA {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 8px 10px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    border: 1px solid var(--primary-border) !important;
    background-color: transparent;
    border-radius: var(--radius-1);
    margin-top: 12px;
}

.PromoCode-promoCodeInput-mWxcq {
    height: 38px;
    font-size: 16px;
    line-height: 24px;
    font-weight: normal;
    border: unset !important;
    background-color: transparent;
    color: var(--primary-foreground);
    -webkit-box-shadow: none;
            box-shadow: none;
    padding: 0 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/PromoCode/PromoCode.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAkB;QAAlB,qBAAkB;YAAlB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mCAA2B;IAA3B,2BAA2B;IAC3B,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,iCAAyB;QAAzB,6BAAyB;YAAzB,yBAAyB;IACzB,mCAA2B;IAA3B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,iBAAiB;IACjB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,kDAAkD;IAClD,6BAA6B;IAC7B,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;IACxB,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAgB;YAAhB,gBAAgB;IAChB,yBAAyB;AAC7B","sourcesContent":[".promoCodeAccordionBtn {\n    display: flex;\n    align-items: start;\n    gap: 4px;\n    padding: 0;\n    background: transparent;\n    border: unset;\n    outline: unset;\n    box-shadow: unset;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: normal;\n    color: var(--primary-link-foreground);\n    text-align: start;\n}\n\n.couponCodeTagSvg {\n    position: relative;\n    top: -2px;\n}\n\n.promoCodeDropDownIcon {\n    transition: all 0.4s linear;\n    position: relative;\n    top: 3px;\n}\n\n.promoCodeAccordionOpen .promoCodeDropDownIcon {\n    transform: rotate(180deg);\n    transition: all 0.4s linear;\n}\n\n.promoCodeInputWrapper {\n    position: relative;\n    display: flex;\n    padding: 8px 10px;\n    align-items: center;\n    border: 1px solid var(--primary-border) !important;\n    background-color: transparent;\n    border-radius: var(--radius-1);\n    margin-top: 12px;\n}\n\n.promoCodeInput {\n    height: 38px;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: normal;\n    border: unset !important;\n    background-color: transparent;\n    color: var(--primary-foreground);\n    box-shadow: none;\n    padding: 0 5px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"promoCodeAccordionBtn": `PromoCode-promoCodeAccordionBtn-_HaCa`,
	"couponCodeTagSvg": `PromoCode-couponCodeTagSvg-Gnx_D`,
	"promoCodeDropDownIcon": `PromoCode-promoCodeDropDownIcon-P_0TP`,
	"promoCodeAccordionOpen": `PromoCode-promoCodeAccordionOpen-WRsW7`,
	"promoCodeInputWrapper": `PromoCode-promoCodeInputWrapper-S4hxA`,
	"promoCodeInput": `PromoCode-promoCodeInput-mWxcq`
};
module.exports = ___CSS_LOADER_EXPORT___;
